import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { m as module } from "./fragmentElement.module.css.js";
function FragmentRemoteComponentBase(options) {
  const [loadState, setLoadState] = useState("blank");
  const [component, setComponent] = useState(null);
  const mountElementRef = useRef(null);
  useEffect(() => {
    const newComponent = options.fragment.createComponent({
      entryName: options == null ? void 0 : options.entryName,
      componentName: options == null ? void 0 : options.componentName
    });
    setComponent(newComponent);
    setLoadState("loading");
    (async () => {
      try {
        await newComponent.create({ router: options == null ? void 0 : options.router });
        if (newComponent.getStatus() === "destroyed") {
          return;
        }
        setLoadState("loaded");
      } catch (error) {
        if (newComponent.getStatus() !== "destroyed") {
          setLoadState("error");
        }
        throw error;
      }
    })();
    return () => {
      newComponent.destroy();
    };
  }, [options == null ? void 0 : options.entryName, options == null ? void 0 : options.componentName]);
  useLayoutEffect(() => {
    component == null ? void 0 : component.properties.setAll(options.properties ?? {});
  }, [component, options.properties]);
  useLayoutEffect(() => {
    if (!mountElementRef.current) return;
    component.mount(mountElementRef.current);
    return () => component.unmount();
  }, [component, loadState]);
  const { loadingFallback, errorFallback } = options;
  if (loadingFallback && (loadState === "loading" || loadState === "blank")) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, loadingFallback);
  }
  if (errorFallback && loadState === "error") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, errorFallback);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !!component && loadState === "loaded" && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: module["fragment-element"] + (options.layout !== "flex" ? ` ${module["fragment-element_layout_flex-contain"]}` : ""),
      "data-testid": `fragment-${options.remote.name}`,
      ref: mountElementRef
    }
  ));
}
export {
  FragmentRemoteComponentBase as F
};
//# sourceMappingURL=FragmentRemoteComponentBasex.js.map
